export default __webpack_public_path__ + "static/media/analytics.872b82eb.svg";